
import { mapState, mapGetters, mapActions } from 'vuex';
import i18n from '@/lib/i18n';
import ReviewAskApi from '@/lib/ReviewAskApi';
import observeEntryImpression from '@/lib/observeEntryImpression';
import ReviewAskEntryCardMobile from './ReviewAskEntryCardMobile';
import ReviewAskEntryCardPc from './ReviewAskEntryCardPc';

export default {
  name: 'ReviewAskEntry',
  components: { ReviewAskEntryCardMobile, ReviewAskEntryCardPc },
  data() {
    return {
      config: null,
      visible: false
    };
  },
  computed: {
    ...mapState(['brandCode', 'preview', 'pageViewId']),
    ...mapState('session', ['sessionParams']),
    ...mapState('review', ['productMetaReviewsCount', 'productId']),
    ...mapGetters(['cremaDomainPrefix']),
    ...mapGetters('widget', ['isMobileViewport']),
    isKoLocale() {
      return i18n.locale.startsWith('ko');
    },
    meetsDisplayConditions() {
      if (!this.config || !this.config.exposed) return false;
      // 미리보기는 후기 목록 응답을 기다리지 않는다. 후기 수는 0건으로 표기된다.
      if (this.preview) return true;
      // 후기 수는 부제 표기에 쓰이므로 도착 전에는 카드를 그리지 않는다.
      return this.productMetaReviewsCount !== null;
    },
    funnelParams() {
      return {
        productId: this.productId,
        pageViewId: this.pageViewId,
        secureDeviceToken: this.sessionParams.secure_device_token
      };
    }
  },
  watch: {
    meetsDisplayConditions(value) {
      if (value) this.visible = true;
    },
    visible(value) {
      // 미리보기는 실노출이 아니므로 판정하지 않는다.
      if (!value || this.preview) return;
      // 카드가 그려진 뒤의 $el을 관찰해야 한다.
      this.$nextTick(() => {
        // 카드 렌더링 에러(errorCaptured)나 destroy로 카드가 없으면 관찰하지 않는다.
        if (this._isDestroyed || !(this.$el instanceof Element)) return;
        this.stopObservingImpression = observeEntryImpression(
          this.$el,
          this.sendImpression
        );
      });
    },
    // product id는 후기 목록 응답으로 도착하므로 mounted가 아니라 여기서 config를 조회한다.
    productId: {
      immediate: true,
      handler(value) {
        if (!this.isKoLocale || this.preview || value === null) return;
        this.fetchConfig();
      }
    }
  },
  created() {
    this.stopObservingImpression = null;
    // 미리보기는 product id 없이 스텁을 쓰므로 여기서 바로 조회한다.
    if (this.isKoLocale && this.preview) this.fetchConfig();
  },
  beforeDestroy() {
    if (this.stopObservingImpression) this.stopObservingImpression();
  },
  errorCaptured() {
    this.visible = false;
    return false;
  },
  methods: {
    ...mapActions('dialog', ['openReviewAskDialog']),
    fetchConfig() {
      new ReviewAskApi(this.brandCode, this.cremaDomainPrefix, this.preview)
        .fetchConfig(this.funnelParams)
        .then(({ data }) => {
          this.config = data;
        })
        .catch(() => {
          // 실패·timeout 시 카드를 삽입하지 않는다.
        });
    },
    sendImpression() {
      new ReviewAskApi(
        this.brandCode,
        this.cremaDomainPrefix,
        this.preview
      ).sendEntryImpression(this.funnelParams);
    },
    onOpen(payload) {
      this.openReviewAskDialog({
        ...payload,
        presets: this.config?.questions || []
      });
    }
  }
};
